module.exports = __webpack_public_path__ + "img/avatar7.2b1a8efd.png";